import { useTranslation } from 'react-i18next'

import CustomDialog from 'components/Shared/Dialog'
import CustomButton from 'components/Shared/Button/index'
import {
  YearFilterValue,
  YearFilterError,
  HandleYearFilterSelectionType,
  HandleYearEntryType,
} from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/Types'
import YOBFilterDialogContent from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/DialogComponent/DialogContentComponent'

interface propsTypes {
  modalState: boolean
  YearOfBirthFilterOptions?: string[]
  handleYearFilterSelection: HandleYearFilterSelectionType
  yearFilterValue: YearFilterValue
  yearFilterError: YearFilterError
  handleYearEntry: HandleYearEntryType
  handleCancel: () => void
  handleFilterByYearOfBirth: () => void
}

const YOBFilterDialog = (props: propsTypes) => {
  const { t } = useTranslation()
  const {
    modalState,
    YearOfBirthFilterOptions,
    handleYearFilterSelection,
    yearFilterValue,
    yearFilterError,
    handleYearEntry,
    handleCancel,
    handleFilterByYearOfBirth,
  } = props
  return (
    <CustomDialog
      isModalOpen={modalState}
      title={t('filters.yob.DialogTitle')}
      showCloseBtn={false}
      onCloseModal={() => handleCancel()}
      enableActionButtons={true}
      primaryBtn={
        <CustomButton
          title={t('common.applyFilters')}
          btnVariant="contained"
          onClick={handleFilterByYearOfBirth}
        />
      }
      secondaryBtn={
        <CustomButton
          title={t('common.cancel')}
          disabled={false}
          onClick={handleCancel}
        />
      }
      content={
        <YOBFilterDialogContent
          {...{
            YearOfBirthFilterOptions,
            handleYearFilterSelection,
            yearFilterValue,
            yearFilterError,
            handleYearEntry,
          }}
        />
      }
    />
  )
}
export default YOBFilterDialog
